/**
 * Keeps the luxury Add to Bag button price in sync with the main product price (under the product name).
 * Copies directly from the live product-price [ref="priceContainer"] element so the button always matches the price on top.
 */
(function () {
  var EVENT = 'variant:update';
  var BUTTON_PRICE_SELECTOR = '[data-dynamic-price]';
  var MAIN_PRICE_SELECTOR = 'product-price [ref="priceContainer"]';

  function syncCta(state) {
    var btn = document.querySelector('.luxury-add-to-bag-button');
    var text = document.querySelector('[data-purchase-cta]');
    var hint = document.querySelector('[data-purchase-state-hint]');
    if (btn) btn.disabled = state !== 'available';
    if (text) {
      text.textContent = state === 'available' ? 'ADD TO BAG' : state === 'sold_out' ? 'SOLD OUT' : 'SELECT OPTIONS';
    }
    if (hint) {
      if (state === 'available') {
        hint.classList.add('hidden');
        hint.textContent = '';
      } else {
        hint.classList.remove('hidden');
        hint.textContent =
          state === 'sold_out'
            ? 'This combination is currently out of stock. Try another metal or colour, or contact us to restock.'
            : 'Choose metal and colour to see price and availability.';
      }
    }
  }

  function copyMainPriceToButton() {
    var buttonPriceEl = document.querySelector(BUTTON_PRICE_SELECTOR);
    if (!buttonPriceEl) return;
    var section = buttonPriceEl.closest('.shopify-section');
    if (!section) return;
    var mainPriceContainer = section.querySelector(MAIN_PRICE_SELECTOR);
    if (!mainPriceContainer) return;
    buttonPriceEl.innerHTML = mainPriceContainer.innerHTML;
  }

  function updateButtonPrice(event) {
    var detail = event.detail;
    if (!detail || !detail.data) return;

    var buttonPriceEl = document.querySelector(BUTTON_PRICE_SELECTOR);
    if (!buttonPriceEl) return;

    var productForm = buttonPriceEl.closest('product-form-component');
    var productId = productForm ? productForm.dataset.productId : null;
    if (productId && detail.data.productId && String(detail.data.productId) !== String(productId)) return;

    /* No matching variant: keep bag label only (no stale price from previous selection). */
    if (detail.resource == null) {
      buttonPriceEl.innerHTML = '';
      syncCta('select');
      return;
    }

    syncCta(detail.resource.available ? 'available' : 'sold_out');

    /* Run after product-price has updated from the same event (next microtask) */
    setTimeout(copyMainPriceToButton, 0);
  }

  function init() {
    document.addEventListener(EVENT, updateButtonPrice);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', copyMainPriceToButton);
    } else {
      copyMainPriceToButton();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
